import React, { FC } from 'react';
import { GrowBolt } from '@menuzen/icon/build/outline';
import StyledComponent from '../../../core/StyledComponent';
import { px2rem } from '../../../core';

export interface ButtonUpgradeProps {
    btnText?: string;
    onClick?: () => void;
}
const PlanUpgradeButton: FC<ButtonUpgradeProps> = ({ onClick, btnText = 'Upgrade' }) => {
    const btnBg = 'linear-gradient(90deg, #6AD6D8 0%, #DA99E5 100%)';
    return (
        <StyledComponent
            xs={{
                display: 'flex',
                alignItems: 'center',
                fontSize: px2rem(12),
                cursor: 'pointer',
                color: 'white',
                padding: `${px2rem(7)} ${px2rem(14)}`,
                borderRadius: 9999,
                backgroundImage: btnBg,
            }}
            onClick={onClick}
        >
            <StyledComponent xs={{ fontSize: px2rem(20) }}>
                <GrowBolt />
            </StyledComponent>
            <span>{btnText}</span>
        </StyledComponent>
    );
};

export default PlanUpgradeButton;
